import * as actionTypes from "../actionTypes/Index";

import { Dispatch } from "react";
import { IActionType } from "../../interfaces/Index";
import {
  updateDeliveryDateInLiveopsApi,
} from "../sources/LiveopsSource";


export const updateDeliveryDateInLiveopsInit = () => ({
  type: actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_INIT,
});

export const updateDeliveryDateInLiveopsSuccess = () => ({
  type: actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_SUCCESS,
});

export const updateDeliveryDateInLiveopsFailed = (
  error: string | object | null
) => ({
  type: actionTypes.UPDATE_DELIVERY_DATE_IN_LIVEOPS_FAIL,
  error,
});

//sends request to backend to update the delivery date of given csv
export const updateDeliveryDateInLiveops =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(updateDeliveryDateInLiveopsInit());
    return updateDeliveryDateInLiveopsApi(payload)
      .then((res) => dispatch(updateDeliveryDateInLiveopsSuccess()))
      .catch((e: object | null | string) =>
        dispatch(updateDeliveryDateInLiveopsFailed(e))
      );
  };
